// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__PBfp2","menuItem_remove":"MenuItem_menuItem_remove__1Glmf","menuItem__chevron":"MenuItem_menuItem__chevron__30cvq"};